import * as z from "zod";
import {
  carrierClaimsDimensionSchema,
  carrierClaimsFilterSchema,
} from "./carrier-claims-analytics-common";

export const CARRIER_CLAIMS_ROUTE_STATUSES = [
  "healthy",
  "warning",
  "critical",
  "idle",
] as const;
export type CarrierClaimsRouteStatus =
  (typeof CARRIER_CLAIMS_ROUTE_STATUSES)[number];

export const carrierClaimsRouteHealthRowSchema =
  carrierClaimsDimensionSchema.extend({
    status: z.enum(CARRIER_CLAIMS_ROUTE_STATUSES),
    open: z.number(),
    unsubmitted: z.number(),
    unsubmittedOver14Days: z.number(),
    filingExhausted: z.number(),
    submitted7d: z.number(),
    decided7d: z.number(),
    lastSubmittedAt: z.string().nullable(),
    lastDecisionAt: z.string().nullable(),
    lastStatusCheckAt: z.string().nullable(),
    checked1d: z.number(),
    checked3d: z.number(),
    checked7d: z.number(),
    checkedOlder: z.number(),
    neverChecked: z.number(),
    abandoned: z.number(),
    approvedUnrefunded: z.number(),
    medianDaysToSubmit: z.number().nullable(),
    medianDaysToDecision: z.number().nullable(),
    medianDaysToRefund: z.number().nullable(),
  });
export type CarrierClaimsRouteHealthRow = z.infer<
  typeof carrierClaimsRouteHealthRowSchema
>;

export const carrierClaimsAlertSchema = z.object({
  routeKey: z.string(),
  routeLabel: z.string(),
  severity: z.enum(["critical", "warning"]),
  message: z.string(),
});
export type CarrierClaimsAlert = z.infer<typeof carrierClaimsAlertSchema>;

export const getCarrierClaimsPipelineHealth = {
  name: "getCarrierClaimsPipelineHealth" as const,
  input: carrierClaimsFilterSchema,
  output: z.object({
    routes: z.array(carrierClaimsRouteHealthRowSchema),
    alerts: z.array(carrierClaimsAlertSchema),
  }),
};

export type GetCarrierClaimsPipelineHealthOutput = z.infer<
  typeof getCarrierClaimsPipelineHealth.output
>;
